import React from 'react'
import { Box } from '@mui/material'
import PropTypes from 'prop-types'
import AccordionReusable from './AccordionReusable'
import { formatAccordion } from 'utils/formatAccordion-utill'

const NewLayout = ({ dealData }) => {
    let listKey = Date.now()

    let purchageDetails = formatAccordion(dealData?.data)

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 12
            }}
        >
            <AccordionReusable customerInfo={dealData?.data?.customer} isCustomerInfo={true} />

            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 4
                }}
            >
                {purchageDetails.map((details, index) => (
                    <React.Fragment key={listKey + details?.order}>
                        <AccordionReusable isCustomerInfo={false} purchageDetails={details} />
                    </React.Fragment>
                ))}
            </Box>
        </Box>
    )
}

NewLayout.propTypes = {
    dealData: PropTypes.object
}

export default NewLayout
